import React from 'react';
import PropTypes from 'prop-types';
import * as S from './ModalOptionStyles';

function getIcon(icon) {
  let tagIcon;

  switch (icon) {
    case undefined || '':
      tagIcon = '';
      break;
    case 'Logo':
      tagIcon = <S.LogoJunto />;
      break;
    case 'Warning':
      tagIcon = <S.WarningIcon />;
      break;
    default:
      tagIcon = '';
  }

  return tagIcon;
}
function ModalOption({ body, icon, hasHTML = false, ...props }) {
  return (
    <S.Modal icon={getIcon(icon)} {...props}>
      {hasHTML && body}

      {!hasHTML && <S.Children dangerouslySetInnerHTML={{ __html: body }} />}
    </S.Modal>
  );
}

ModalOption.propTypes = {
  body: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
    PropTypes.element
  ]),
  icon: PropTypes.string,
  hasHTML: PropTypes.bool
};

export default ModalOption;
